import { AccessControlManager } from "../_resources/accesscontrol-manager.js";
import { getSupaACLOwnedResources } from "../_resources/supa-helpers.js";
import { supabaseClient } from "../auth/supabase.service.js";
import { holdButton } from "../_resources/ui-library.js";
import "./ByUsersView.styl";

export default class ByUsersView {
  constructor({ dom, message }) {
    this.dom = dom;
    this.message = message;
    this.container = null;
    this.accessData = [];
  }

  async loadAccessData() {
    // Load all ACL data for resources where user is owner
    const { ok, error } = await getSupaACLOwnedResources();
    
    if (error) {
      console.error('Error loading access data:', error);
      this.message.bad(error);
      return { error };
    }
    
    this.accessData = ok;
    return { data: this.accessData };
  }

  async render() {
    const container = this.dom;
    this.container = container;
    
    container.html('');
    container.append('h1').text('Access Audit by User');
    
    const { error } = await this.loadAccessData();
    if (error) return;
    
    // Group by email domain, then by email
    const grouped = this.groupByDomain(this.accessData);
    
    // Sort domains alphabetically
    const sortedDomains = Object.keys(grouped).sort();
    
    sortedDomains.forEach((domain) => {
      this.renderDomainSection(container, domain, grouped[domain]);
    });
  }

  groupByDomain(data) {
    const grouped = {};
    
    data.forEach(item => {
      const domain = item.email.split('@')[1] || 'unknown';
      if (!grouped[domain]) {
        grouped[domain] = {};
      }
      if (!grouped[domain][item.email]) {
        grouped[domain][item.email] = [];
      }
      grouped[domain][item.email].push(item);
    });
    
    return grouped;
  }

  renderDomainSection(container, domain, users) {
    const section = container.append('div')
      .attr('class', 'audit-domain-section');
    
    // Sort emails alphabetically
    const sortedEmails = Object.keys(users).sort();
    
    sortedEmails.forEach((email) => {
      this.renderUserSection(section, email, users[email]);
    });
  }

  renderUserSection(container, email, accessList) {
    const userSection = container.append('div')
      .attr('class', 'audit-user-section');
    
    userSection.append('h3')
      .text(`${email}: ${accessList.length} resource${accessList.length !== 1 ? 's' : ''}`);
    
    const tableContainer = userSection.append('div');  
    
    // Sort access list by scope then resource
    const sortedAccessList = accessList.sort((a, b) => {
      if (a.scope !== b.scope) return a.scope.localeCompare(b.scope);
      return a.resource.localeCompare(b.resource);
    });
    
    // Create manager with column configuration
    const manager = new AccessControlManager({
      container: tableContainer,
      message: this.message,
      showAddButton: false,
      showExplanations: false,
      tableClass: 'admin-table',
      columns: [
        { field: 'scope', label: 'Scope' },
        { field: 'resource', label: 'Resource' },
        { field: 'level', label: 'Level', editable: true },
        { field: 'parent', label: 'Granted by', render: (d) => d || '—' },
        { field: 'actions', label: 'Actions' }
      ],
      onUpdate: () => {
        // Re-render entire view to reload all users' data
        this.render();
      }
    });
    
    // Set data directly (already loaded)
    manager.data = sortedAccessList;
    
    // Render without loading
    manager.container.html('');
    const table = tableContainer.append("table").attr("class", manager.tableClass);
    manager.renderTableHeader(table);
    manager.renderTableRows(table);
  }
}
